<template>
    <div 
        class="border-1 rounded-xl shadow-md"
        :class="{
            'bg-indigo-200 col-span-1 row-span-2 md:grid md:grid-rows-2 md:grid-cols-1 md:h-full': position === 3,
            'bg-white': position < 3,
            'md:grid md:grid-cols-2 md:h-full col-span-2': position == 2
        }"
    >
        <div 
            v-if="position > 1"
            class="
                relative
                hidden md:flex 
                justify-center 
                md:row-start-1 md:row-span-1 md:col-span-1
            "
            :class="{
                'bg-indigo-200': position === 3
            }"
        >
            <illustration 
                name="cartographie" 
                class="
                    absolute bottom-9 xl:bottom-20
                    transform scale-110 xl:scale-150
                "
            />
        </div>

        <div 
            class="
                py-10 md:p-5 xl:p-8 
                flex flex-col space-y-5 md:space-y-2 lg:space-y-5 2xl:space-y-10
            "
            :class="{
                'xl:row-start-2 xl:row-span-1 xl:col-span-1 md:m-1.5 bg-white border rounded-xl z-10': position === 3,
            }"
        >
            <div class="text-2xl md:text-xl xl:text-2xl text-center">Cartographie collective</div>
            
      <router-link 
        :to="{name: 'Informationsgénérales'}"
        class="flex items-center justify-center"
      >
        <div 
          v-if="datas && Object.keys(datas).length > 0 && backdoor" 
          class="
                        flex justify-center 
                        md:w-11/12 md:h-10/12 lg:h-10/12 lg:w-full xl:h-full
                    "
        >
          <doughnut
            id-chart="datas"
            title=""
            :labels="datas.longLabels"
            :values="datas.datas"
            thickness="70"
            :colors="[color('pink'), color('indigo'), color('gray')]"
            title-color="#000000"
            :title-upper-case="false"
            position-legend="bottom"
            height="220"
            :maintain-aspect-ratio="false"
          />
        </div>
        <div 
          v-else 
        >
          <p class="text-center text-gray-600">
            Aucune donnée à afficher
          </p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Illustration from './../Illustration';
import Doughnut from './../Charts/Doughnut';

import Constants from './../../constants';

export default {
  components:{
    Illustration,
    Doughnut,
  },

    props:{
        datas:{
            type:Object,
        },
        position:{
            type: Number,
            default: 3,
        }
    },

  data(){
    return{
      constants: Constants
    };
  },

  methods:{
    color(c){
      if(c == 'indigo'){
        return '#3A18D1';
      }else if(c == 'pink'){
        return '#FF1C80';
      }
      else if(c == 'gray'){
        return '#919AA6';
      }
      else if(c=='elevenColors'){
        return ['#ff1c80', '#E61B89', '#D31B91', '#C01A99', '#AD1AA1', '#9A19A9', '#8619B1', '#7319B9', '#5B18C3', '#3A18D1', '#919AA6'];
      }else if(c=='tenColors'){
        return ['#ff1c80', '#E21B8B', '#CA1A95', '#B21A9F', '#9A19A9', '#8219B3', '#6A18BD', '#5B18C3', '#3A18D1', '#919AA6'];
      }else if(c=='nineColors'){
        return ['#ff1c80', '#DD1B8D', '#C01A99', '#A31AA5', '#8619B1', '#6A18BD', '#5618C5', '#3A18D1', '#919AA6'];
      }else if(c=='eightColors'){
        return ['#ff1c80', '#D81B8F', '#B61A9D', '#9519AB', '#7319B9', '#5B18C3', '#3A18D1', '#919AA6'];
      }
    },
  },

  computed:{
    ...mapGetters({
      listModules: 'template/listModulesPages',
      role: 'auth/role',
      permissions: 'auth/permissions',
      backdoor: 'app/backdoor'
    }),
  },
};
</script>